<article class="cardscan" [ngClass]="{'modeone': isModeOne, 'modetwo': isModeTwo}">
  <sot-backbtn (click)="back()"></sot-backbtn>
  <div class="logo">
    <span langkey="ordertype_title"></span>
    <img *ngIf="has_logo_image" [src]="logo_image_path" class="ya_image" />
  </div>

  <div class="content">
    <div class="box">
      <ng-container>
        <h3 langkey="process_start_card_scann">Jetzt scannen</h3>
        <div class="icon" inlineSVG="sot/sot-icon.svg#sot-cardscan" [setSVGAttributes]="{class: 'box-icon'}"></div>
        <p langkey="process_start_card_scann_text">Bitte die Vorgangskarte unten auf den Scanner legen</p>
      </ng-container>
      <div class="downpay" inlineSVG="sot/sot-icon.svg#sot-down_arrows" [setSVGAttributes]="{class: 'arrows'}"></div>
    </div>
  </div>
</article>